if(!com.inq.flash.messagingframework) {
 com.inq.flash.messagingframework = {}
}
if(!com.inq.flash.messagingframework.connectionhandling) {
 com.inq.flash.messagingframework.connectionhandling = {}
}
/* End of package definition for com.inq.flash.messagingframework.connectionhandling */

